import { Collapse, CollapseProps } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// components
import FinancialStatementItem from '../components/financialStatementItem';
import Icon from 'utils/icon';

// styles
import { CollapseItemStyles } from 'utils/styles/collapseItem';
import { onGetFinancialStatements } from '../services/financialStatementServices';
import FilePreview from 'components/filePreview/filePreview';
import { isRTL } from 'core/services/language';
import DataRoomItem from '../../dataRoom/components/dataRoomItem';
import NotificationService from 'core/services/notification';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import NoData from 'components/noData/noData';

interface CompanyInfFinancialStatementPageProps {}

const CompanyInfFinancialStatementPage: FunctionComponent<CompanyInfFinancialStatementPageProps> = () => {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [files, setFiles] = useState<CollapseProps['items']>([]);

	useEffect(() => {
		getFinancialStements();
	}, []);

	const getFinancialStements = async () => {
		try {
			setIsLoading(true);

			const response = await onGetFinancialStatements();

			const files: CollapseProps['items'] = [];

			if (response) {
				Object.entries(response).forEach(([key, value]) => {
					files.push({
						key,
						label: <h6 className="fw-medium mb-0">{key}</h6>,
						children: <FinancialStatementItem period={value} />,
						style: CollapseItemStyles,
					});
				});

				setFiles(files);
			}

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
		}
	};

	return isLoading ? (
		<LoadingComponent />
	) : files && files.length ? (
		<Collapse
			bordered={false}
			expandIconPosition="end"
			className="file-room"
			style={{ background: 'transparent' }}
			expandIcon={({ isActive }) => (
				<Icon
					name="rightArrow"
					height={18}
					color="#555"
					style={{ transition: 'all .2s ease-in-out', transform: isActive ? 'rotate(-90deg)' : 'rotate(90deg)' }}
				/>
			)}
			items={files}
		/>
	) : (
		<div className="mt-5">
			<NoData />
		</div>
	);
};

export default CompanyInfFinancialStatementPage;
